export default __webpack_public_path__ + "static/media/haj1.6ffe6e16.JPG";